var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8332 8.23334L9.00817 4.40834C8.85203 4.25313 8.64082 4.16602 8.42067 4.16602C8.20051 4.16602 7.9893 4.25313 7.83317 4.40834C7.75506 4.48581 7.69307 4.57798 7.65076 4.67953C7.60845 4.78108 7.58667 4.89 7.58667 5.00001C7.58667 5.11002 7.60845 5.21894 7.65076 5.32049C7.69307 5.42204 7.75506 5.51421 7.83317 5.59168L11.6665 9.40834C11.7446 9.48581 11.8066 9.57798 11.8489 9.67953C11.8912 9.78108 11.913 9.89 11.913 10C11.913 10.11 11.8912 10.2189 11.8489 10.3205C11.8066 10.422 11.7446 10.5142 11.6665 10.5917L7.83317 14.4083C7.67625 14.5642 7.58765 14.7759 7.58687 14.9971C7.58609 15.2182 7.67319 15.4306 7.829 15.5875C7.98482 15.7444 8.19659 15.833 8.41772 15.8338C8.63886 15.8346 8.85125 15.7475 9.00817 15.5917L12.8332 11.7667C13.3013 11.2979 13.5643 10.6625 13.5643 10C13.5643 9.33751 13.3013 8.7021 12.8332 8.23334Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRight);
export default __webpack_public_path__ + "static/media/angle-right.78550c8edb9232f3f9884e49ea4076c3.svg";
export { ForwardRef as ReactComponent };